module.exports = __webpack_public_path__ + "img/2021年8月18日广州微林软件有限公司旗下产品164.543ce37b.jpg";